import { useFrame } from '@react-three/fiber';
import { useMemo, useRef } from 'react';
import type { Group } from 'three';
import { useGameStore } from '../../simulation/store';

export function WeatherEffects() {
  const weather = useGameStore((state) => state.weather);
  const groupRef = useRef<Group>(null);
  const drops = useMemo(
    () =>
      Array.from({ length: 120 }, (_, index) => ({
        x: ((index * 37) % 24) - 12,
        z: ((index * 53) % 24) - 12,
        y: 2 + ((index * 11) % 8) * 0.35
      })),
    []
  );

  useFrame(({ clock }) => {
    if (groupRef.current) {
      groupRef.current.position.y = -((clock.elapsedTime * 2.8) % 1.4);
    }
  });

  if (weather.kind !== 'rain') {
    return weather.kind === 'clouds' || weather.kind === 'fog' ? (
      <group position={[0, 6.5, 0]}>
        {Array.from({ length: 8 }, (_, index) => (
          <mesh key={`cloud-${index}`} position={[-9 + index * 2.8, 0.4 * Math.sin(index), -8 + (index % 3) * 5]}>
            <sphereGeometry args={[0.8 + (index % 3) * 0.12, 10, 8]} />
            <meshBasicMaterial color="#eef0e6" transparent opacity={weather.kind === 'fog' ? 0.22 : 0.32} />
          </mesh>
        ))}
      </group>
    ) : null;
  }

  return (
    <group ref={groupRef}>
      {drops.map((drop, index) => (
        <mesh key={`rain-${index}`} position={[drop.x, drop.y, drop.z]} rotation={[0.35, 0, 0]}>
          <boxGeometry args={[0.01, 0.35, 0.01]} />
          <meshBasicMaterial color="#b8d5da" transparent opacity={0.35 + weather.intensity * 0.45} />
        </mesh>
      ))}
    </group>
  );
}
